import { FormField, FormButton } from './FormField';

export const RegisterForm = ({ formData, formErrors, touched, isLoading, onFieldChange, onFieldBlur, onSubmit }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4" noValidate>
      {/* Email */}
      <div>
        <FormField
          id="email"
          name="email"
          label="Email"
          type="email"
          value={formData.email}
          onChange={(e) => onFieldChange('email', e.target.value)}
          onBlur={() => onFieldBlur('email')}
          error={formErrors.email}
          touched={touched.email}
          placeholder="admin@example.com"
          required
          autoComplete="email"
        />
      </div>

      {/* Prénom et Nom */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField
          id="first_name"
          name="first_name"
          label="Prénom"
          type="text"
          value={formData.first_name}
          onChange={(e) => onFieldChange('first_name', e.target.value)}
          onBlur={() => onFieldBlur('first_name')}
          error={formErrors.first_name}
          touched={touched.first_name}
          placeholder="Jean"
          required
          autoComplete="given-name"
        />

        <FormField
          id="last_name"
          name="last_name"
          label="Nom"
          type="text"
          value={formData.last_name}
          onChange={(e) => onFieldChange('last_name', e.target.value)}
          onBlur={() => onFieldBlur('last_name')}
          error={formErrors.last_name}
          touched={touched.last_name}
          placeholder="Dupont"
          required
          autoComplete="family-name"
        />
      </div>

      {/* Mots de passe */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField
          id="password"
          name="password"
          label="Mot de passe"
          type="password"
          value={formData.password}
          onChange={(e) => onFieldChange('password', e.target.value)}
          onBlur={() => onFieldBlur('password')}
          error={formErrors.password}
          touched={touched.password}
          placeholder="••••••••"
          required
          autoComplete="new-password"
        />

        <FormField
          id="password_confirm"
          name="password_confirm"
          label="Confirmer le mot de passe"
          type="password"
          value={formData.password_confirm}
          onChange={(e) => onFieldChange('password_confirm', e.target.value)}
          onBlur={() => onFieldBlur('password_confirm')}
          error={formErrors.password_confirm}
          touched={touched.password_confirm}
          placeholder="••••••••"
          required
          autoComplete="new-password"
        />
      </div>

      {/* Bouton */}
      <div className="pt-4">
        <FormButton
          type="submit"
          isLoading={isLoading}
          disabled={isLoading}
          className="w-full text-lg"
        >
          S'inscrire
        </FormButton>
      </div>
    </form>
  );
};
